import { render } from "./TagList.vue?vue&type=template&id=56229f95&ts=true"
import script from "./TagList.vue?vue&type=script&lang=ts"
export * from "./TagList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/sora/Documents/ss/kochi_bus_admin_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__